export enum SigningSessionStatus {
  Open = 0,
  Verified = 1,
  Active = 2,
  Expired = 3,
  Closed = 4,
}

export enum SigningSessionEndReason {
  UserClosed = 0,
  IdleTimeout = 1,
  HardCap = 2,
  OtpDeliveryFailed = 3,
  OtpAttemptsExhausted = 4,
}

export enum SigningSessionEventType {
  Opened = 0,
  OtpSent = 1,
  OtpVerified = 2,
  OtpFailed = 3,
  ActivityRegistered = 4,
  Expired = 5,
  Closed = 6,
}

export interface SigningSessionUserSnapshot {
  userName?: string;
  fullName?: string;
  phoneNumber?: string;
  emailAddress?: string;
}

export interface SigningSessionOtpStatus {
  isPending: boolean;
  expiresAt?: string;
  secondsUntilExpiry: number;
  attemptsRemaining: number;
}

export interface SigningAuthenticatorStatus {
  isConfigured: boolean;
  activatedAt?: string;
}

export interface SigningAuthenticatorEnrollment {
  secret: string;
  otpAuthUri: string;
  qrCodeDataUri: string;
  issuer: string;
  accountName: string;
}

export interface SigningSession {
  id: string;
  status: SigningSessionStatus;
  canSign: boolean;
  isTerminal: boolean;
  openedAt: string;
  verifiedAt?: string;
  lastActivityAt: string;
  idleExpiresAt: string;
  hardExpiresAt: string;
  idleTimeoutSeconds: number;
  hardCapSeconds: number;
  secondsUntilIdleExpiry: number;
  secondsUntilHardExpiry: number;
  activityCount: number;
  endedAt?: string;
  endReason?: SigningSessionEndReason;
  userSnapshot: SigningSessionUserSnapshot;
  otp: SigningSessionOtpStatus;
}

export interface SigningSessionEvent {
  id: string;
  sessionId: string;
  eventType: SigningSessionEventType;
  occurredAt: string;
  recordedAt: string;
  actorUserId: string;
  actorName?: string;
  ipAddress?: string;
  userAgent?: string;
  metadata?: string;
}
